import React, {useEffect, useState} from 'react'
import {makeStyles} from "@material-ui/core";
import Tr from "translations/Translations";
import Page from "components/Page";
import Workspace from "components/Workspace";
import GridBlock from "components/GridBlock";
import Button from "components/Button";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import BoldTypography from "components/BoldTypography";
import RouterPath from "libs/RouterPath";
import PurchasingGroupTemplateService from "services/PurchasingGroupTemplateService";
import Form from "components/Form";
import Loading from "components/Loading";
import PurchasingGroupTemplateForm from "./components/PurchasingGroupTemplateForm";
import VS from "constants/ValidationShema";
import SaveIcon from '@material-ui/icons/Save'
import {connect} from "react-redux";
import {PurchasingGroupTemplateFieldType} from "./constants/PurchasingGroupTemplateFieldType";
import useSnackbar from "hooks/useSnackbar";

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    },
    back: {
        position: "absolute"
    },
    save: {
        position: "absolute",
        right: 0
    },
    bar: {
        position: 'sticky',
        zIndex: theme.zIndex.appBar - 1,
        top: 67,
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        borderBottom: `solid 1px ${theme.palette.primary.main}`,
    },
}));

function PurchasingGroupTemplate(
    {
        match,
        formSubmit
    }) {
    const classes = useStyles();
    const FORM_ID = "PURCHASING_GROUP_TEMPLATE";
    const templateId = match.params.id;
    const [tpl, setTpl] = useState(null);
    const [hasEdit, setHasEdit] = useState(false);
    const {enqueueSuccessSnackbar} = useSnackbar();

    useEffect(() => {
        PurchasingGroupTemplateService.getTemplate(templateId).then((resp) => {
            if (resp) {
                const {hasEdit, ...other} = resp;
                setTpl(other)
                setHasEdit(hasEdit)
            }
        });
    }, [templateId])

    const goToList = () => {
        RouterPath.redirect(RouterPath.createPath(RouterPath.purchasingGroup.MP_PURCHASING_GROUP_TEMPLATES_LIST))
    }

    const saveTemplate = (values) => {
        const {fields, fieldsCount, ...other} = values;
        const req = {
            ...other,
            fields: fields.map((x, i) => ({
                ...x,
                ordinalNumber: i + 1,
                aggregatedFields: x.type === PurchasingGroupTemplateFieldType.AGGREGATE ? x.aggregatedFields : null
            }))
        }
        PurchasingGroupTemplateService.saveTemplate(templateId, req).then(resp => {
            if (resp && resp.success) {
                enqueueSuccessSnackbar(Tr('saved'))
                RouterPath.redirect(RouterPath.createPath(RouterPath.purchasingGroup.MP_PURCHASING_GROUP_TEMPLATES_TEMPLATE_ID, {
                    id: resp.result
                }))
            }
        })

    }

    return <Page className={classes.root}>
        <Workspace>
            <GridBlock justify="space-between" className={classes.bar}>
                <Button className={classes.back} variant="outlined" Icon={ArrowBackIosIcon} onClick={goToList}>{Tr("back_to_list")}</Button>
                <BoldTypography variant="h5">{Tr("purchase_groups_template")}</BoldTypography>
                {hasEdit ? <Button className={classes.save} Icon={SaveIcon} onClick={() => formSubmit[FORM_ID]()}>{Tr("save")}</Button> : <div></div>}
            </GridBlock>


            {
                !tpl ? <Loading/> :
                    <Form
                        id={FORM_ID}
                        initialValues={{...tpl, fieldsCount: ""}}
                        validationSchema={
                            VS.lazy((values) => {
                                const {fields} = values;

                                const obj = {
                                    name: VS.stringMax(250),
                                    description: VS.stringMax(1000),
                                    fields: VS.arrayOf(VS.lazy((field) => {
                                        return VS.object({
                                            name: VS.stringMax(250).test(
                                                'uniqueName',
                                                Tr('v_names_no_unique'),
                                                (formValue, testContext) => {
                                                    const index = fields.findIndex(x => x.name === formValue && field.uniqueId !== x.uniqueId);
                                                    return index === -1;
                                                }
                                            ),
                                            type: VS.string(),
                                            required: VS.requiredBoolean(),
                                            aggregatedFields: VS.any().when("type", {
                                                is: PurchasingGroupTemplateFieldType.AGGREGATE,
                                                then: VS.arrayRequired(),
                                                otherwise: VS.any().strip()
                                            })

                                        })
                                    })),
                                    fieldsCount: fields.length === 0 ? VS.immediatelyError(Tr("required_field")) : VS.any()
                                }
                                return VS.object(obj);
                            })
                        }
                        onSubmit={saveTemplate}
                    >{(formikProps) => {
                        return <PurchasingGroupTemplateForm hasEdit={hasEdit} formikProps={formikProps}/>
                    }}</Form>
            }


        </Workspace></Page>
}

PurchasingGroupTemplate.propTypes = {}

export default connect((state) => ({
    formSubmit: state.form
}), {})(PurchasingGroupTemplate);
	
